import DiscoverAllocatorResult from './DiscoverAllocatorResult'

export default DiscoverAllocatorResult
